var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Observer } from "mobx-react-lite";
import React from "react";
import { ContextColor } from "../../constants/color.enum";
import { useControllers } from "../../hooks/controller.hooks";
import { useCreateResizeQueryWithRef } from "../../hooks/useCreateResizeQueryWithRef.hook";
import joinClassName from "../../utils/className.utils";
import { getContextColorStyle } from "../../utils/colors.utils";
import { renderRenderable } from "../../utils/components.utils";
import { useProps, useStore } from "../../utils/mobx.utils";
import './Overlay.scss';
var Overlay = function (props) {
    var UI = useControllers().UI;
    var p = useProps(props);
    var _a = useCreateResizeQueryWithRef(), ref = _a.ref, overlayQuery = _a.query;
    var s = useStore(function () { return ({
        overlay: p.overlay,
        config: p.overlay.config,
        get viewStyle() {
            var _a;
            return __assign(__assign({}, getContextColorStyle(ContextColor.Primary, p.overlay.config.color)), { paddingTop: UI.fromTablet ? 64 + ((_a = p.index) !== null && _a !== void 0 ? _a : 0) * 10 : undefined, '--OverlayHeight': Math.ceil(overlayQuery.height) + 1 + 'px' });
        },
        get overlayStyle() {
            return {
                maxWidth: UI.fromTablet ? s.overlay.config.width : undefined,
            };
        }
    }); });
    var renderComponent = function () {
        return renderRenderable(p.overlay.config.component);
    };
    return React.createElement(Observer, { children: function () {
            return React.createElement("section", { className: joinClassName("OverlayView", s.overlay.status, s.config.className), style: s.viewStyle, "data-name": s.config.name, "data-id": s.overlay.id, "data-appearance": s.config.appearance || 'sheet', "data-cy": s.overlay.config.dataCy, key: s.overlay.id },
                !s.overlay.noBackdrop && React.createElement("span", { className: "OverlayBackdrop" }),
                React.createElement("div", { className: "Overlay", style: s.overlayStyle, ref: ref },
                    React.createElement("div", { className: "OverlayInner" }, renderComponent())));
        } });
};
export default Overlay;
